import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e25a7af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "editor-node-loader"
};
const _hoisted_2 = {
    key: 0,
    class: "content-resource-placeholder"
};
const _hoisted_3 = { class: "content-resource-placeholder-resources" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_FriedH3 = _resolveComponent("FriedH3");
    const _component_FriedH5 = _resolveComponent("FriedH5");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_FriedRadioButton = _resolveComponent("FriedRadioButton");
    const _component_FriedH4 = _resolveComponent("FriedH4");
    const _component_EditorNodeEmptyState = _resolveComponent("EditorNodeEmptyState");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.placeholder.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_FriedSpinner, { size: 48 }),
                _createVNode(_component_FriedH3, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('content_placeholder_is_loading_resource')), 1)
                    ]),
                    _: 1
                })
            ]))
            : (_openBlock(), _createBlock(_component_EditorNodeEmptyState, {
                key: 1,
                icon: "editor-block",
                heading: _ctx.t('content_resource_placeholder'),
                description: _ctx.emptyStateDescription
            }, {
                action: _withCtx(() => [
                    (_ctx.hasPlaceholder)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_ctx.node.content)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_FriedH5, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('content_element_placeholder_description_room_context')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_FriedParagraph, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.node.content), 1)
                                        ]),
                                        _: 1
                                    })
                                ], 64))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeholder.resources, (resource) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: resource.id,
                                        class: _normalizeClass([
                                            'content-resource-placeholder-row',
                                            {
                                                deleted: _ctx.isResourceUnavailable(resource),
                                            },
                                        ])
                                    }, [
                                        _createVNode(_component_FriedRadioButton, {
                                            disabled: "",
                                            value: resource.id
                                        }, null, 8, ["value"]),
                                        _createVNode(_component_FriedH4, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(resource.title), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ], 2));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["heading", "description"]))
    ]));
}
